import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IRemoveTranslationRepoResponse = IRepoResponse<200> | IRepoResponse<400 | 500, string>;

export type IRemoveTranslationRepo = IRepo<[number | string], IRemoveTranslationRepoResponse>;

export const RemoveTranslationRepoType = Symbol.for('RemoveTranslationRepo');

@bind(RemoveTranslationRepoType)
export class RemoveTranslationRepo implements IRemoveTranslationRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.delete({ url: urlMaker(`/translations/${id}`) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
